// import axios from 'axios'

//const KEEP_ALIVE_TIME = 420000; 
const KEEP_ALIVE_TIME = 25000;

export class Socket {
    constructor( url, axios ) {
        this._url               = url;
        this._connection        = null;
        this._onMessageCallback = null;
        this._connectionId      = null; 
        this._userName          = null; 
        this._isConnected       = false;
        this._axios             = axios;
    }

    //2025-05-23 jazz
    getSocketUrlWithKey = async () =>{
        const response = await this._axios.post(`${process.env.MIX_API_BASEURL}/api/generate-token`, { email: this._userName });

        return `${this._url}?token=${response.data.token.trim()}`;
    }

    getConnectionId = async () => {
        do {
            await new Promise( r => setTimeout(r, 500) );
        } while ( !this._connectionId )

        return this._connectionId;
    }

    isConnected = async () =>{
        do {
            await new Promise( r => setTimeout(r, 500) );
        } while ( !this._connectionId )

        return this._isConnected;
    }

    getConnectionObject = async () => {
        do {
            await new Promise( r => setTimeout(r, 500) );
        } while ( !this._connection )

        return this._connection;
    }

    connect = async ( userEmail, srsfunc = null, isForVerify = null ) => {
        if(isForVerify){ //added mae 2025-10-07
            userEmail = srsfunc.SRSDefaults.DecompressData(userEmail);
        }
        
        if(this._connection){
            this._connection.close();
            this.sendHeartBeat(false);
        }

        try {

            const response = await this._axios.post(`${process.env.MIX_API_BASEURL}/api/generate-token`, { email: userEmail });

            this._connection = new WebSocket(`${this._url}?token=${response.data.token.trim()}`);
            this._userName = userEmail

            this._connection.onopen = () => {
                console.log('WebSocket connection established');
                this._isConnected = true;
                this.sendHeartBeat(true); //2025-05-23 jazz
            };

            this._connection.onmessage = ( event ) => {
                const jsonObj = JSON.parse( event.data )

                if ( jsonObj.isInfoOnly ) {
                    if ( jsonObj.isInfoOnly == 1 ) {
                        this._connectionId = jsonObj.connectionId
                    }
                } else {
                    if ( this._onMessageCallback ) { 
                        if ( jsonObj.data ) { 
                            const eventData = JSON.parse( event.data);
                            this._onMessageCallback( eventData );
                        }
                    }
                }  
            };

            this._connection.onclose = () => {
                console.log('WebSocket disconnected');
                this._isConnected = false;
                //window.location.reload()
                this.sendHeartBeat(false);
            };

            this._connection.onerror = (error) => {
                console.error('WebSocket error:', error);
                window.location.reload() //2025-05-27 jazz, on error reload
                this._isConnected = false;
                this.sendHeartBeat(false);
            };
        } catch(error) {
            this.sendHeartBeat(false);
            console.log(error.message)
        }
    }

    joinRoom = async ( socketRoomObj ) =>{
        try{
            if( socketRoomObj ){
                do {
                    await new Promise(r => setTimeout(r, 500));
                } while ( this._connection.readyState !== WebSocket.OPEN ) 

                socketRoomObj.action = 'joinRoom'
                this._connection.send( JSON.stringify(socketRoomObj) );
            }
        }catch(e){
            alert('socket not connected') //2025-05-23 jazz
        }
    }

    sendMessage = async ( message, version = null ) => {
        if ( this._connection && this._connection.readyState === WebSocket.OPEN ) {
            message.action = 'sendMessage';
            message.version = version;

            this._connection.send(JSON.stringify(message));
        } else {
            console.error('WebSocket is not open. Unable to send message.');
        }
    }

    setOnMessageCallback = (callback) => {
        this._onMessageCallback = callback;
    }

    closeConnection = ( isFailedToLogin = null ) =>{
        //console.log(this._connection)

        if( isFailedToLogin ){
            this._connection.close(); //added mae 2025-10-07
        }
        
        this._isConnected = false;
        this.sendHeartBeat(false);
    }

    sendHeartBeat = (shouldKeepAlive, timer = null) => {
        clearInterval(this.keepAliveInterval);

        if (shouldKeepAlive) {
            // Send a keep-alive message every 8 minutes (480000 milliseconds)
            this.keepAliveInterval = setInterval(async () => {
                if (this._connection.readyState === WebSocket.OPEN) {
                    try {
                        await this.sendMessage({
                            systemName: "SRS",
                            request: "keepAlive",
                            roomName: process.env.MIX_SOCKET_ROOM,
                            userName: this._userName,
                            data: 'keep-alive'
                        });
                        console.log('...💗');
                    } catch (error) {
                        console.error('Error sending keep-alive:', error);
                    }
                } else {
                    window.location.reload();
                    console.warn('WebSocket is not open. Current state:', this._connection.readyState);
                }
            }, (timer ? timer : KEEP_ALIVE_TIME));  
        } else {
            // Clear the interval if not keeping alive
            if (this.keepAliveInterval) {
                clearInterval(this.keepAliveInterval);
                this.keepAliveInterval = null;

                console.log('Keep-alive messages stopped');
            }
        }
    }
}